import styles from '../TransactionDetails.module.scss';
import ButtonWithIcon from 'components/ButtonWithIcon';
import PrintIcon from 'icons/PrintIcon';
import ReactToPrint from 'react-to-print';

interface Props {
  id: string;
  printRef: React.RefObject<HTMLDivElement>;
}

function Header({id, printRef}: Props) {
  return (
    <div className={styles.header}>
      <div>
        <h1 className={styles.title}>
          Transaction <span className={styles.title_id}>#{id}</span>
        </h1>
      </div>
      <div>
        <ReactToPrint
          trigger={() => (
            <ButtonWithIcon
              className={styles.print_button}
              color="ghost"
              size="lg"
              icon={<PrintIcon size={16} />}
            >
              Print
            </ButtonWithIcon>
          )}
          content={() => printRef.current}
        />
      </div>
    </div>
  );
}

export default Header;
